import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface BudgetExhaustedProps extends BaseTemplateProps {
  campaignName: string
  campaignLink: string
  campaignBudget: string
  averageDailySpend: string
}

export const BudgetExhausted: TemplateDefinition<BudgetExhaustedProps> = {
  renderParams: (props: BudgetExhaustedProps) => ({
    messageKey: 'notificationsDomain.templates.budgetExhausted',
    values: {
      campaignName: props.campaignName,
      campaignLink: props.campaignLink,
      campaignBudget: props.campaignBudget,
      averageDailySpend: props.averageDailySpend,
    },
  }),
  getLink: (props: BudgetExhaustedProps): string => props.campaignLink,
}
